module.exports = __webpack_public_path__ + "img/Schumann's Bistro.b9ff9d28.svg";